import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarOpen: true,
  sidebarCollapsed: localStorage.getItem('upsc_admin_sidebar_collapsed') === 'true',
  colorMode: localStorage.getItem('upsc_admin_color_mode') || 'light',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebar(state, { payload }) {
      state.sidebarOpen = payload;
    },
    toggleSidebarCollapsed(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
      localStorage.setItem('upsc_admin_sidebar_collapsed', String(state.sidebarCollapsed));
    },
    setColorMode(state, { payload }) {
      state.colorMode = payload;
      localStorage.setItem('upsc_admin_color_mode', payload);
    },
  },
});

export const { toggleSidebar, setSidebar, toggleSidebarCollapsed, setColorMode } = uiSlice.actions;
export default uiSlice.reducer;
